<template>
    <router-link :to="{name: 'surveys.'+notification.data.type+'.fill', params: {survey_id: notification.data.id, kindergarten_id: notification.kindergarten_id, org_id: notification.org_id}}" class="d-flex flex-row px-3 py-2 diary-likes e3-notification-row">
        <div class="profile-image-container">
            <ProfileImage v-if="notification.kindergarten" :image-url="notification.kindergarten.logo" :name="notification.kindergarten.name" size="sm"/>
        </div>
        <div class="d-flex flex-column ml-2 w-100">
            <div v-if="notification.kindergarten" class="font-weight-bold">{{ truncate(notification.kindergarten.name, 30) }}</div>
            <div v-else-if="notification.organization" class="font-weight-bold">{{ truncate(notification.organization.name, 30) }}</div>
            <div v-else>ELIIS</div>
            <div class="text-break">
                {{ truncate(notificationText, 50) }}
            </div>
        </div>
    </router-link>
</template>

<script>
import {truncate} from '@/filters';

export default {
    name: 'NewSurveyNotification',
    props: {
        notification: Object
    },
    computed: {
        notificationText() {
            return this.$t('Notification - New survey', {survey: this.notification.data.name});
        }
    },
    methods: {
        truncate // TODO: Vue3 remove
    }
};
</script>

<style scoped>

</style>
